module.exports = __webpack_public_path__ + "static/media/tete.3954c344.jpeg";